import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/topicLinkTypeStatusService";
const store = {};
const mutations = {
    GET_TOPIC_LINKTYPE_STATUS_LIST(state, posts) {
        state.topicLinkTypeStatusList = posts;
    },
    GET_TOPIC_LINKTYPE_STATUS_DETAIL(state, posts) {
        state.topicLinkTypeStatusDetail = posts;
    },
    SAVE_TOPIC_LINKTYPE_STATUS_DETAIL() { 
    }
};
const state = {
    topicLinkTypeStatusList: [],
    topicLinkTypeStatusDetail: {}
};
const getters = {};
const actions = {
    getTopicLinkTypeStatusList({ commit }) {
        return axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success === true) {
                    commit('GET_TOPIC_LINKTYPE_STATUS_LIST', res.data.list);
                }
                else { 
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    getTopicLinkTypeStatusDetail({ commit }, { tlsId }) {
        return axios
            .get(baseUri + '/GetDetail', { params: { tlsId } })
            .then(res => {
                if (res.data.success === true) {
                    commit('GET_TOPIC_LINKTYPE_STATUS_DETAIL', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
                return res;
            });
    },
    saveTopicLinkTypeStatusDetail({ commit }, record) { 
        var formData = new FormData();
        formData.append("data", JSON.stringify(record));
        return axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success === true) {
                    commit('SAVE_TOPIC_LINKTYPE_STATUS_DETAIL', res.data);
                }
                else { 
                    alert(res.data.errorMessage);
                }
                return res;
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}